import { initialiseGoogleAuth, getGoogleAuthCode } from "common/google/auth";

define(function (require) {
  var $ = require("jquery");
  var loginValidation = require("site/mobile/log-in-page-validation");
  var persistentFields = require("site/mobile/checkout/persistent-field-store");
  var login = require("./log-in-page-login");
  const loginEvents = require("site/common/analytics/login-events");
  const cfTurnstile = require("site/common/cf-turnstile");
  var validate = require("site/mobile/validate");
  const changeCheckoutPage = require("site/mobile/checkout/page-changer");
  var { attachShowHidePasswordHandler } = require("site/page/show-hide-password.ts");
  require("common/util/persist-input");
  var PageConfig = require("common/page-config");
  var _ = require("underscore");

  const isTurnstileCheckEnabled = _.contains(
    PageConfig.uiChannelFeatures,
    "TURNSTILE_CAPTCHA_WEB"
  );

  // Set based on pageType arg in addTrackingEventListeners
  let trackingFunctions;

  function createTrackingFunctions (pageType) {
    trackingFunctions = pageType === "checkoutLogin" ?
      loginEvents.trackEventLogInCheckout() :
      loginEvents.trackEventLogInPage();
  }

  function addKeyboardSubmissionEvent (form) {
    const submit = _.debounce(form.submit, 1000);
    $("input", form).keypress(function (e) {
      if (e.which === 13) {
        submit();
      }
    });
  }
  function keyboardSubmission ($page) {
    addKeyboardSubmissionEvent($page.find(".login-form"));
    addKeyboardSubmissionEvent($("#forgotten-password-form"));
  }
  function backBehaviour () {
    if (window.location.hash === "#logout-connect") {
      $(".signin-page .button-back").attr("href", "/");
      $(".signin-page .button-back").attr("rel", "external");
      $(".signin-page .button-back").removeAttr("data-rel");
    }
  }
  function setupGuestCheckout () {
    $(".new-user").off("click").on("click", function () {
      trackingFunctions.asGuest();

      var currentUri = window.location.hash.split("?");

      changeCheckoutPage("checkout-page", currentUri[1]);
      if ($(".login-email").val() !== "") {
        $("#email").val($(".login-email").val());
      }
    });
  }

  const $emailField = $("input[name='login-email']");
  const $passwordField = $("input[name='login-psswd']");
  const $signupLink = $(".profileRegisterLink");
  const $forgotPasswordLink = $("a[href=#password-page]");

  function addTrackingEventListeners (pageType) {
    createTrackingFunctions(pageType);

    $emailField.on("click", trackingFunctions.email);
    $passwordField.on("click", trackingFunctions.password);
    $signupLink.on("click", trackingFunctions.signUp);
    $forgotPasswordLink.on("click", trackingFunctions.forgotPassword);
  }

  function removeTrackingEventListeners () {
    $emailField.off("click", trackingFunctions.email);
    $passwordField.off("click", trackingFunctions.password);
    $signupLink.off("click", trackingFunctions.signUp);
    $forgotPasswordLink.off("click", trackingFunctions.forgotPassword);
  }

  function addGoogleLoginListener ($page, variant) {
    const $button = $page.find('[data-id="google-login"]');
    initialiseGoogleAuth()
      .then(() => {
        $button.removeAttr("disabled");
        $button.on("click", (event) => {
          event.preventDefault();
          getGoogleAuthCode()
            .then((authCode) => {
              login({
                $loginForm: $page.find(".login-form"),
                validator: validate,
                googleIdToken: authCode,
                pageVariant: variant
              });
            })
            .catch((error) => {
              trackingFunctions.socialAuthErrorEvent({
                network: "google",
                error
              });
              if (error === "popup_closed_by_user") {
                return;
              }
              validate.errorPopup("google-auth-fail");
            });
        });
      })
      .catch((error) => {
        trackingFunctions.socialAuthErrorEvent({
          network: "google",
          error: error.message ? error.message : error
        });
      });
  }

  function setUp (variant, pageName) {
    if ($(".signin-page").length === 0) {
      return;
    }
    var $page = $(pageName);
    var $loginForm = $(".account-login .login-form", $page);
    var $loginEmailInput = $loginForm.find(".login-email");

    loginValidation(variant, pageName, validate);
    keyboardSubmission($page);
    backBehaviour();
    setupGuestCheckout();
    addGoogleLoginListener($page, variant);

    $loginForm.find(".form-action a").on("click", function () {
      $loginForm.submit();
    });
    // Setup field persisting
    $loginForm.off(".login-handler").on("change.login-handler", ".persistent-field", function (event) {
      persistentFields.saveField(event.currentTarget);
    });
    $("#forgotten-password-form .form-action a").on("click", function () {
      $("#forgotten-password-form").submit();
    });
    $loginEmailInput.on("blur", function () {
      var userEmailAddress = $loginEmailInput.val();

      $("#psswd-email").val(userEmailAddress);
    });
    $("#psswd-email").on("blur", function () {
      var userEmailAddress = $("#psswd-email").val();

      $(".login-email").val(userEmailAddress);
    });
    $("#email").on("blur", function () {
      var userEmailAddress = $("#email").val();

      $(".login-email").val(userEmailAddress);
      $("#psswd-email").val(userEmailAddress);
    });
    $("#success-message").bind({
      popupafterclose: () => window.history.go(-1)
    });

    attachShowHidePasswordHandler({
      viewId: ".account-login .view-icon",
      hideId: ".account-login .hide-icon",
      inputPasswordSelector: ".login-psswd"
    });
    attachShowHidePasswordHandler({
      viewId: ".login-verify-account-popup  .view-icon",
      hideId: ".login-verify-account-popup  .hide-icon",
      inputPasswordSelector: ".login-verify-account-popup .password"
    });
    var cfTurnstileElement = document.querySelector(".ui-page-active .cf-turnstile-container");
    if (isTurnstileCheckEnabled && cfTurnstileElement) {
      cfTurnstile.init();
    }
  }
  function targetUri (uri) {
    $(".signin-page .form-action a").data("target-uri", uri);
  }
  function silentTargetUri (uri, changePageOptions) {
    var $anchor = $(".signin-page .form-action a");

    $anchor.data("silent-target-uri", uri);
    if (changePageOptions) {
      $anchor.data("silent-target-changepage-options", changePageOptions);
    }
  }
  function displayExplanation (explanation) {
    $(".signin-page .form-intro").html(explanation).show();
  }
  function showMinimalLogin () {
    $(".signin-page .forgot-password").hide();
  }
  return {
    setUp: setUp,
    showMinimalLogin: showMinimalLogin,
    displayExplanation: displayExplanation,
    targetUri: targetUri,
    silentTargetUri: silentTargetUri,
    addTrackingEventListeners,
    removeTrackingEventListeners
  };
});
